import { createContext } from "react"
import { initialState } from "./reducer"
import { TopBannerContextAction, TopBannerContextState } from "./types"

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const TopBannerContext = createContext<[TopBannerContextState, React.Dispatch<TopBannerContextAction>]>([initialState, () => {}])
